import { page, type FeatureRoutes } from "@/app/feature";

// The back office: full screen (no player navigation), never linked from the player's UI. The gate is its
// own small chunk; the back office's screens load only once the server says this session is an admin's.
export const routes: FeatureRoutes = {
  fullscreen: [{ path: "admin/*", lazy: page(() => import("./AdminGate")) }],
};
